import { merge } from 'merge';
import { Awareness } from 'y-protocols/awareness.js';
import { createAutoIncrementIdGenerator, createAutoIncrementIdGeneratorByClientId, nanoid, uuidv4, } from '../utils/id-generator.js';
import { AwarenessStore } from '../yjs/awareness.js';
import { BlockSuiteDoc } from '../yjs/index.js';
export var Generator;
(function (Generator) {
    /**
     * Default mode, generator for the unpredictable id
     */
    Generator["NanoID"] = "nanoID";
    Generator["UUIDv4"] = "uuidV4";
    /**
     * This generator is trying to fix the real-time collaboration on debug mode.
     * This will make generator predictable and won't make conflict
     * @link https://docs.yjs.dev/api/faq#i-get-a-new-clientid-for-every-session-is-there-a-way-to-make-it-static-for-a-peer-accessing-the-doc
     */
    Generator["AutoIncrementByClientId"] = "autoIncrementByClientId";
    /**
     * **Warning**: This generator mode will crash the collaborative feature
     *  if multiple clients are adding new blocks.
     * Use this mode only if you know what you're doing.
     */
    Generator["AutoIncrement"] = "autoIncrement";
})(Generator || (Generator = {}));
const FLAGS_PRESET = {
    enable_legacy_validation: true,
    enable_expand_database_block: false,
    enable_bultin_ledits: false,
    readonly: {},
};
export class Store {
    constructor({ id, providerCreators = [], awareness, idGenerator, defaultFlags, } = { id: nanoid('workspace') }) {
        this.providers = [];
        this.spaces = new Map();
        this.id = id || '';
        this.doc = new BlockSuiteDoc({ guid: id });
        this.awarenessStore = new AwarenessStore(this, awareness ?? new Awareness(this.doc), merge(true, FLAGS_PRESET, defaultFlags));
        if (typeof idGenerator === 'function') {
            this.idGenerator = idGenerator;
        }
        else {
            switch (idGenerator) {
                case Generator.AutoIncrement: {
                    this.idGenerator = createAutoIncrementIdGenerator();
                    break;
                }
                case Generator.AutoIncrementByClientId: {
                    this.idGenerator = createAutoIncrementIdGeneratorByClientId(this.doc.clientID);
                    break;
                }
                case Generator.UUIDv4: {
                    this.idGenerator = uuidv4;
                    break;
                }
                case Generator.NanoID:
                default: {
                    this.idGenerator = nanoid;
                    break;
                }
            }
        }
        this.providers = providerCreators.map(creator => creator(this.id, this.doc, {
            awareness: this.awarenessStore.awareness,
        }));
    }
    registerProvider(providerCreator, id) {
        const provider = providerCreator(id ?? this.id, this.doc, {
            awareness: this.awarenessStore.awareness,
        });
        this.providers.push(provider);
        return provider;
    }
    addSpace(space) {
        this.spaces.set(space.id, space);
    }
    removeSpace(space) {
        this.spaces.delete(space.id);
    }
}
//# sourceMappingURL=store.js.map